import { createFileRoute } from "@tanstack/react-router";
import { faqHead, FaqRouteComponent } from "@/app-clients/app-shell/faq-route";

export const Route = createFileRoute("/faq")({
    component: FaqRouteComponent,
    head: faqHead,
});
